import React, { FC, useContext } from 'react';
import injectSheet from 'react-jss';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import { useRouter } from 'Utils/router';
import { Button } from 'Components/Buttons';
import styleSheet from './styles';

interface Props {
  applyEnable: any;
  changeCols?: any;
  tableCols: any;
  setTableCols: any;
  originalCols: any;
  sortColumn: any;
  sortDirection: any;
  classes: any;
  setExportSettings: (val: any) => void;
  cogFocus?: () => void;
}

const ActionButtons: FC<Props> = (props: Props) => {
  const {
    applyEnable,
    changeCols,
    tableCols,
    setTableCols,
    originalCols,
    setExportSettings,
    sortColumn,
    sortDirection,
    classes,
    cogFocus,
  } = props;

  const {
    helpers: { View },
    actions: { track },
  } = useContext(ProductAnalyticsContext);

  const { location } = useRouter();

  // When Cancel or Apply are clicked, we want the focus to go back to the cog.
  const cancelClick = () => {
    setExportSettings(false);
    setTableCols(originalCols);
    cogFocus();
  };

  const applyClick = () => {
    track('column_configured', {
      column_list: tableCols.join(','),
      screen: View(location.pathname),
    });

    changeCols(tableCols, sortColumn, sortDirection);
    setExportSettings(false);
    cogFocus();
  };

  return (
    <div className={classes.actionButtons}>
      <Button buttonType="defaultClear" onClick={cancelClick}>
        Cancel
      </Button>
      <span style={{ marginLeft: '5px' }}>
        <Button
          buttonType="defaultBlue"
          disabled={!applyEnable}
          onClick={applyClick}
        >
          Apply
        </Button>
      </span>
    </div>
  );
};

ActionButtons.defaultProps = {
  changeCols: undefined,
  cogFocus: () => {},
};

export default injectSheet(styleSheet)(ActionButtons);
